import { server } from "../utils/server";

// import OtplessSdk from "otpless-js-sdk";
// const sdkIntance = new OtplessSdk(
//   {
//       appId: "OTPLess:MOAHFGEKOXAIPOFISDXXOOSGFAQFYLIT",
//       enableErrorLogging: true
//   }
// );


const sendOTP = (data) => {
    return server.post("investor/auth/login", data)
        .then(res => {           
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return err?.response?.data;
        })
}

const resendOTP = (data) => {
    return server.post("investor/auth/resendLoginOtp", data)
        .then(res => {           
            return res.data;
        })
        .catch(err => {
            return err?.response?.data
        })
}

const getUser = (data) => {
    return server.get("investor/auth/" + data)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err?.response?.data;
        })
}


const verifyOTP = (data) => {
    return server.post("investor/auth/verifyLogin", data)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err?.response?.data;
        })
}

const googleLogin = (data) => {
    return server.post("investor/auth/google/login", data)
        .then(res => {
            
            return res.data;
        })
        .catch(err => {
            return err?.response?.data;
        })
}

const acceptConditions = () => {
    return server.patch("investor/auth/acceptConditions")
        .then(res => {
            
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return err?.response?.data;
        })
}

const savePersonalDetails = (data) => {
    return server.post("investor/auth/saveDetails", data)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err?.response?.data;
        })
}

const updatePersonalDetails = (data) => {
    return server.put("investor/auth/updateDetails", data)
        .then(res => {
            
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return err?.response?.data;
        })
}

const getDltWalletByUser = (investorId) => {
    return server.get(`investor/auth/getDltWallet/${investorId}`)
        .then(res => {
            
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return err?.response?.data;
        })
}

const updateBankDetails = (data) => {
    return server.put("investor/auth/updateBankDetails", data)
        .then(res => {
            
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return null;
        })
}

const completeKyc = (data) => {
   
    
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    return server.post("investor/auth/completeKyc", data,config)
        .then(res => {
            
            return res.data;
        })
        .catch(err => {
            return err?.response?.data;
        })
}

const completeManualKyc = (data) =>{
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    return server.post("investor/auth/completeManualKyc",data, config)
    .then(res=>{
        
        return res.data;
    })
    .catch(err=>{
        return err?.response?.data || { success: false, message: "Network error" };
    })
}

const createBlockChainAcc = (data) =>{
    return server.post("investor/auth/createWallet",data)
    .then(res=>{
        
        return res.data;
    })
    .catch(err=>{
        return err?.response?.data;
    })
}

const submitMneomonic = (data) => {
    return server.post("realXAdmin/investor/optin", data)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err?.response?.data;
        })
}

const encryptCredentials = (data) => {
    return server.post("algorand/auth/encrypt", data)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return null;
        })
}

const sendMnemonicThroughMail = (data) => {
    return server.post("/algorand/auth/credentialMail", data)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return null;
        })
}

const submitEncryptedText = (data) => {
    return server.post("algorand/auth/submit-mneomonic", data)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return err?.response?.data;
        })
}

const submitAadhaar = (data) => {
    return server.post("investor/auth/aadharinitiate", data)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err?.response?.data;
        })
}

const verifyAadhaar = (data) => {
    return server.post("investor/auth/aadharotpverify", data)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err?.response?.data;
        })
}

const verifyPan = (data) => {
    return server.post("investor/auth/verifyPan", data)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            return err?.response?.data;
        })
}

const getUserAgreement = () => {
    return server.get("/agreement/active")
    .then(res => {
        return res.data
    })
    .catch(err => {
        return err?.response?.data
    })
}

const encryptCredentialsPolygon = (data) => {
    return server.post("dlt/polygon/encrypt", data)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            console.log(err);
            return null;
        })
}


const authServices = {
    sendOTP,
    resendOTP,
    verifyOTP,
    googleLogin,
    acceptConditions,
    savePersonalDetails,
    updatePersonalDetails,
    updateBankDetails,
    completeKyc,
    completeManualKyc,
    createBlockChainAcc,
    getUser,
    submitMneomonic,
    encryptCredentials,
    submitEncryptedText,
    submitAadhaar,
    verifyAadhaar,
    verifyPan,
    sendMnemonicThroughMail,
    getDltWalletByUser,
    getUserAgreement,
    encryptCredentialsPolygon
}

export default authServices;